import { Component, HostListener } from '@angular/core';


import { FormControl, UntypedFormGroup } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginFields, generateLoginForm } from '../../../../routes/auth/login/form.function';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerComponent } from '../../../components/banner/banner.component';
import { InlineInputControlComponent } from '../../../components/form/inline-input-control/inline-input-control.component';
import { CheckboxControlComponent } from '../../../components/form/checkbox-control/checkbox-control.component';
import { RegisterDialogComponent } from '../register-dialog/register-dialog.component';
import { ForgotPswDialogComponent } from '../forgot-psw-dialog/forgot-psw-dialog.component';
import { AuthErrorDialogComponent } from '../auth-error-dialog/auth-error-dialog.component';
import { AuthSuccessDialogComponent } from '../auth-success-dialog/auth-success-dialog.component';
import { StateService } from '../../../../core/state/old/state.service';
import { DataService } from '../../../../core/providers/data/data.service';
import { SignInMutation, SignInMutationVariables } from '../../../../graphql/generated/generated-types';
import { SIGN_IN } from './sign-in.graphql';
import { MessageService } from 'primeng/api';
import { NotAvailableOverlayComponent } from '../../../components/not-available-overlay/not-available-overlay.component';
import { ToastSeverity } from '../../../notification/notification.component';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'app-login-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    DividerModule,
    BannerComponent,
    InlineInputControlComponent,
    CheckboxControlComponent,
    RegisterDialogComponent,
    AuthSuccessDialogComponent,
    AuthErrorDialogComponent,
    ForgotPswDialogComponent,
    NotAvailableOverlayComponent,
  ],
  templateUrl: './login-dialog.component.html',
  styleUrl: './../auth-dialog-pages.scss'
})
export class LoginDialogComponent {
  @HostListener('document:keydown.enter', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (this.loginForm.valid) {

    }
  }

  public loginForm: UntypedFormGroup = generateLoginForm();
  public LoginFields = LoginFields;

  public submited = false;
  public loading = false;
  public staySignedIn: FormControl = new FormControl(false);

  public user!: any;


  constructor(
    private dialogRef: DynamicDialogRef, private dialogService: DialogService,
    private dataService: DataService, private stateService: StateService, private messageService: MessageService,
    public authService: AuthService) {
  }



  public signIn() {
    this.dataService.mutate<SignInMutation, SignInMutationVariables>(SIGN_IN, {
      emailAddress: this.loginForm.get(LoginFields.Email)?.value,
      password: this.loginForm.get(LoginFields.Password)?.value,
      rememberMe: this.staySignedIn.value,
    }).subscribe({
      next: ({ login }) => {
        switch (login.__typename) {
          case 'CurrentUser':
            this.stateService.setState('signedIn', true);
       
            this.dialogRef.close(true);
            break;
          case 'NativeAuthStrategyError':
          case 'InvalidCredentialsError':
            this.messageService.add({ severity: ToastSeverity.Error, key: 'notifications', summary: 'Error', detail: `${(login as any).message}` });
            break;
        }
      },
    });
  }
  public closeDialog() {
    this.dialogRef.close();
  }

  public openRegisterDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(RegisterDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }

  public openForgotPasswordDialog() {
    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(ForgotPswDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }


  public openAuthErrorDialog() {

    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(AuthErrorDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }

  public openAuthSuccessDialog() {

    this.dialogRef.close();

    const dialogRef: DynamicDialogRef = this.dialogService.open(AuthSuccessDialogComponent,
      {
        styleClass: 'auth-custom-dialog',
        modal: true,
        showHeader: false,
        closeOnEscape: true,
        dismissableMask: true,
      });

    dialogRef.onClose.subscribe((result) => {

    })
  }


}
